import { render, staticRenderFns } from "./sendOrderToOdooModal.vue?vue&type=template&id=f6441d7e&"
import script from "./sendOrderToOdooModal.vue?vue&type=script&lang=js&"
export * from "./sendOrderToOdooModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports